// Two installable apps on the same site: "Anou Appran" (everything) and "Anou Appran Lecture" (Reading kit only).
let deferred = null;
const subs = new Set();
const ping = () => subs.forEach((f) => f());
const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

if (typeof window !== "undefined") {
  const flag = new URLSearchParams(window.location.search).get("app");
  if (flag === "1" || (window.navigator.standalone === true && window.location.pathname.startsWith("/lecture"))) sessionStorage.setItem("aa_reading_app", "1");
  if (flag === "full") sessionStorage.setItem("aa_full_app", "1");
  if (flag === "0") ["aa_reading_app", "aa_full_app"].forEach((k) => sessionStorage.removeItem(k));
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; ping(); });
  window.addEventListener("appinstalled", () => { deferred = null; ping(); });
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
}

// Store wrappers open /lecture?app=1 (Reading) or /parent?app=full (everything)
export const isReadingApp = () => sessionStorage.getItem("aa_reading_app") === "1";
export const isInstalledApp = () => isReadingApp() || sessionStorage.getItem("aa_full_app") === "1" || standalone();
export const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const canInstall = () => Boolean(deferred);
export const onInstallChange = (f) => { subs.add(f); return () => subs.delete(f); };

// In the browser, /lecture offers the Reading app; every other page offers the full app
export function syncManifest(pathname) {
  const reading = isReadingApp() || pathname.startsWith("/lecture");
  const set = (id, attr, value) => document.getElementById(id)?.setAttribute(attr, value);
  if (document.getElementById("aa-manifest")?.getAttribute("href") === (reading ? "/lecture.webmanifest" : "/app.webmanifest")) return;
  set("aa-manifest", "href", reading ? "/lecture.webmanifest" : "/app.webmanifest");
  set("aa-apple-icon", "href", reading ? "/reading-app-apple-180.png" : "/app-apple-180.png");
  set("aa-apple-title", "content", reading ? "Lecture" : "Anou Appran");
  deferred = null;
  ping();
}

export async function promptInstall() {
  if (!deferred) return false;
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  deferred = null;
  ping();
  return outcome === "accepted";
}
